import { AppPageLayout } from "@/components/common/AppPageLayout";
import { hooks as h } from "@/hooks";
import { useProfileCopy } from "@/features/i18n/profileCopy";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/team")({
    component: TeamLayout,
});

function TeamLayout() {
    const copy = useProfileCopy();
    h.useNav([{ label: copy.myTeam, route: { to: "/team" } }]);

    return (
        <AppPageLayout width="full" as="div">
            <Outlet />
        </AppPageLayout>
    );
}
